module.exports = __webpack_public_path__ + "img/关于我们.475e0c93.png";